/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color);
  --min-height: calc(var(--nve-ref-size-1000) + var(--nve-ref-size-200));
  --padding: var(--nve-ref-size-300);
  display: block;
  width: 100%;
}

[internal-host] {
  background: var(--background);
  border-bottom: var(--border-bottom);
  padding: var(--padding);
  color: var(--color);
  min-height: var(--min-height);
  display: flex;
  align-items: center;
}
